import { useEffect, useReducer, useState } from 'react';
import { fetchUserDetails } from '../../userDetailsUtils';
import {
  getCabConfiguration,
  getCabLandingPlaceHolder,
  getCabOffers
} from '../../cabsLandingAPIs';
import { getCabsPokusData } from '../cabsPokus';

export const useInitApiData = () => {
  const [userData, setUserData] = useState<any>(null);
  const [
    cabLandingPlaceHolderConfigData,
    setcabLandingPlaceHolderConfigData
  ] = useState<any>(null);

  const initCabLandingApiCalls = async () => {
    const userDataPromise = fetchUserDetails();
    const cabLandingPlaceHolderConfigPromise = getCabLandingPlaceHolder();

    const [userData, cabLandingPlaceHolderConfig] = await Promise.all([
      userDataPromise,
      cabLandingPlaceHolderConfigPromise
    ]);

    await getCabsPokusData();
    return { userData, cabLandingPlaceHolderConfig };
  };

  useEffect(() => {
    (async () => {
      const {
        userData,
        cabLandingPlaceHolderConfig
      } = await initCabLandingApiCalls();
      setUserData(userData);
      setcabLandingPlaceHolderConfigData(cabLandingPlaceHolderConfig);
    })();
  }, []);

  return {
    userData,
    cabLandingPlaceHolderConfigData
  };
};
